/**
 * Trailblazers per-player scanner ACTIVITY — what each member of a team is doing
 * with their scanner right now, pushed to that team so every member's Round Info
 * overlay can show a live status block per teammate.
 *
 * Activity only: no dig outcome ever travels here (found/near/nothing stay
 * private to the digger), and there is no offline state — a disconnected member
 * simply reads `idle`.
 *
 * Deliberately separate from `trlTriangulation.ts`: activity exists on every node
 * type (single-image, triangulation, fork, checkpoint and the legacy no-map path),
 * while that module is specifically the home of the simultaneous-broadcast rules.
 * The two are complementary — `TRL_TRIANGULATION_STATE` answers "is the team at
 * 2/3?", which a per-player view cannot, and this answers "who is in position?".
 */
import { TRL_SEISMIC_CAST_MS } from './trlTriangulation';
/**
 * How long after a cast should have landed the server gives up on it and drops
 * the player back to idle. Mirrors `STALE_CAST_GRACE_MS` in the live-triangulation
 * module — a cast whose completion never arrives (crash, lost log line) must not
 * leave a teammate's block lit forever.
 */
export const TRL_ACTIVITY_CAST_GRACE_MS = 8000;
/** Total life of a `scanning`/`triangulating` signal with no end event. */
export const TRL_ACTIVITY_CAST_TTL_MS = TRL_SEISMIC_CAST_MS + TRL_ACTIVITY_CAST_GRACE_MS;
/**
 * PROCESSING is only ever brief — the dig lands within a log line or two of the
 * cast completing. Backstop for the digs that never arrive (blocked scanner, no
 * active node, a lost log line).
 */
export const TRL_ACTIVITY_PROCESSING_TTL_MS = 6000;
/** CANCELLED lingers long enough for teammates to register it, then decays. */
export const TRL_ACTIVITY_CANCELLED_TTL_MS = 2500;
